<script>
import Vue from "vue";
import ArrayTableFieldItems from "@/components/table-elements/array-table-field-items.vue";

export default Vue.extend({
    name: "array-table-field-modal",
    components: {ArrayTableFieldItems},
    props: {
        row: {
            required: false,
            default: null,
        },
        field: {
            required: true,
        },
        index: {
            required: false,
            default: null
        },
        datatable: {
            required: false,
            default: null
        },
        store: {
            required: false,
            default: null
        },
        type: {
            required: false,
            default: 'details'
        },
        icon_class: {
            required: false,
            default: 'fa-eye'
        },
        tab_index: {
            required: false,
            default: -1,
        }
    },
    mounted() {
    }
})
</script>

<template>
    <div>
        <div>
            <!-- Button trigger modal -->
            <button type="button" class="btn btn-sm btn-clean btn-icon btn-icon-sm" data-toggle="modal" :data-target="'#array-field-modal-' + index + '-' + type">
                <i :class="['fa', icon_class]"></i>
            </button>

            <!-- Modal -->
            <div class="modal fade" :id="'array-field-modal-' + index + '-' + type" :tabindex="-1">
                <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-type" :id="'array-field-label-modal-' + index + '-' + type">{{ $t('label.' + type) }}</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true"></span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <array-table-field-items
                                :datatable="datatable"
                                :index="index"
                                :field="field"
                            ></array-table-field-items>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<style scoped>

</style>